import clsx from "clsx";
import type { ComponentProps } from "react";

import type { FilterItemType } from "@shared/content-types/types";
import { Button } from "@shared/ui/button";
import { Body } from "@shared/ui/typography/body";

import s from "./filters-list.module.scss";

export type FiltersListProps = ComponentProps<"div"> & {
  className?: string;
  filters: FilterItemType[];
  onFilterClick: (value: string) => void;
  activeFilter: string;
  disabled?: boolean;
  ref?: React.Ref<HTMLDivElement>;
};

export const FiltersList = (props: FiltersListProps) => {
  const { className, filters, onFilterClick, activeFilter, ref } = props;

  return (
    <div ref={ref} className={clsx(s.root, className)}>
      {filters?.map((item, idx) =>
        item && (item.uid != null || item.type != null) ? (
          <Button
            key={`filter-${item?.uid ?? idx}-${idx + 1}`}
            className={clsx(s.button, {
              [s.activeButton]: activeFilter === item.uid,
            })}
            onClick={() => item?.uid != null && onFilterClick(item.uid)}
          >
            <Body size="uppercase" weight="semiBold">
              {item?.type ?? ""}
            </Body>
          </Button>
        ) : null,
      )}
    </div>
  );
};

FiltersList.displayName = "FiltersList";
